<template>
<div class="main-body">
  <div class="card">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-5">
                  <h4 class="card-title mb-0">
                    Marketplace Store Management <small class="text-muted">stores</small>
                  </h4>
              </div><!--col-->

              <div class="col-sm-7">
                  <header-button></header-button>
              </div><!--col-->
          </div><!--row-->

          <div class="row mt-4">
              <div class="col">
                  <div class="table-responsive">
                      <table class="table">
                        <colgroup>
                          <col width="2%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="8%">
                          <col width="10%">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>{{ $t('marketplace.store.store_account') }}</th>
                            <th>{{ $t('marketplace.store.store_name') }}</th>
                            <th>{{ $t('marketplace.store.store_user_id') }}</th>
                            <th>{{ $t('marketplace.store.store_token') }}</th>
                            <th>{{ $t('marketplace.store.store_email') }}</th>
                            <th>{{ $t('marketplace.store.store_currency') }}</th>
                            <th>{{ $t('marketplace.store.remark') }}</th>
                            <th>{{ $t('marketplace.store.status') }}</th>
                            <th>{{ $t('marketplace.store.operation') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(marketplaceStore, index) in marketplaceStores" :key="index">
                            <td>{{ index+1 }}</td>
                            <td>{{ marketplaceStore.store_account }}</td>
                            <td>{{ marketplaceStore.store_name }}</td>
                            <td>{{ marketplaceStore.store_user_id }}</td>
                            <td>{{ marketplaceStore.store_token }}</td>
                            <td>{{ marketplaceStore.store_email }}</td>
                            <td>{{ marketplaceStore.store_currency }}</td>
                            <td>{{ marketplaceStore.remark }}</td>
                            <td>
                              <span class="badge badge-success" v-if="marketplaceStore.status">{{ $t('marketplace.store.active') }}</span>
                              <span class="badge badge-secondary" v-else>{{ $t('marketplace.store.in_active') }}</span>
                            </td>
                            <td>
                              <router-link :to="{ path: '/marketplace/store/' + marketplaceStore.id + '/edit' }">
                                <b-button variant="primary btn-sm ml-1"><i class="fa fa-pencil"></i></b-button>
                              </router-link>
                               <b-button variant="danger btn-sm ml-1" @click.stop.prevent="handleDelete(marketplaceStore.id)"><i class="fa fa-trash"></i></b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div><!--col-->
          </div><!--row-->
      </div><!--card-body-->
  </div><!--card-->
  <loading-panel v-if="showLoadingPanel"></loading-panel>
</div>
</template>

<script>
import HeaderButton from '@/views/components/marketplace/store/HeaderButton'
import LoadingPanel from '@/components/LoadingPanel'

export default {
  name: 'Stores',
  components: {
    HeaderButton,
    LoadingPanel
  },
  mounted () {
    this.axios.get('/marketplace/store').then(response => {
      this.marketplaceStores = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      marketplaceStores: [],
      showLoadingPanel: false
    }
  },
  methods: {
    handleDelete (shiperId) {
      this.$swal({
        title: this.$t('operation.delete.title'),
        text: this.$t('operation.delete.text'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('operation.delete.confirm_button')
      }).then((result) => {
        if (result.value) {
          this.showLoadingPanel = true
          this.axios.delete('/marketplace/store/' + shiperId).then(() => {
            // this.showLoadingPanel = false
            // this.$router.push('/marketplace/store')
            location.reload()
          }).catch(error => {
            this.showLoadingPanel = false
            this.$swal({
              icon: 'error',
              title: error.data.message
            })
          })
        }
      })
    }
  }
}
</script>
